import React, {useState} from 'react'
import {useAuth} from "../../../providers/AuthProvider";
import Form, {FormInputComponent} from "../../../components/form/Form";

const SupplierInfoStep = React.forwardRef(({supplierOrg, isDisabled, onChange, ...props}, formRef) => {

    const {auth} = useAuth();

    const [editingIndex, setEditingIndex] = useState(false);


    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">
                                Agency Info
                            </h3>

                            {/*{this.constructor.LastUpdatedMethod && this.renderLastUpdated(this.constructor.LastUpdatedMethod)}*/}
                        </div>

                        <h5 className="form-subtitle">
                            Give your agency some information
                        </h5>
                    </div>
                </div>
            </div>

            <div className="talent-role-form">
                <Form
                    ref={formRef}
                    title={false}
                    subtitle={null}
                    showRequired
                    submitButton={false}
                    onChange={(model) => {
                        let updates = {...model}
                        for (let [key, value] of Object.entries(model)) {
                            updates = TB.set(updates, key, value)
                        }
                        onChange(updates)
                    }}
                    model={supplierOrg}
                    fields={[]}
                    isDisabled={isDisabled}>

                    <div className="flex flex-col">
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-8/12">
                                <FormInputComponent
                                    fieldName="name"
                                    value={supplierOrg.name}
                                    type={'text'}
                                    label="Agency Name"
                                    maxLength={255}
                                    required={true}
                                    placeholder="Name"
                                    style={styles.field}
                                />
                            </div>
                        </div>

                        <div className="field-section flex-row">

                            <div className="field px-3.5 basis-5/12">
                                <FormInputComponent
                                    fieldName="size"
                                    value={supplierOrg.size}
                                    label={TB.trans('clients.edit_company_profile.size_label')}
                                    type={'select'}
                                    required={true}
                                    options={laravel.client_sizes}
                                />
                            </div>
                            <div className="field px-3.5 basis-5/12">
                                <FormInputComponent
                                    fieldName="website"
                                    value={supplierOrg.website}
                                    label="Website"
                                    placeholder="URL"
                                    type="url"
                                    maxLength={255}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-8/12">
                                <FormInputComponent
                                    fieldName="location"
                                    value={supplierOrg.location}
                                    type={'location'}
                                    label="Location"
                                    maxLength={255}
                                    required={true}
                                    placeholder="Search location..."
                                    style={styles.field}
                                />
                            </div>
                        </div>

                        <hr/>


                        <div className="flex flex-col items-start">
                            <div className="field-section flex row">
                                <div className="field px-3 5">
                                    <label className="col-form-label">
                                        Approved Email Domains
                                        <span className="required-symbol"> *</span>
                                    </label>
                                </div>
                            </div>

                            {supplierOrg.approved_email_domains?.length > 0 ? TB.map(supplierOrg.approved_email_domains, (domain, dIndex) => (
                                <div className="field-section flex-row"
                                     key={`domain-${dIndex}`}>
                                    <div className="field px-3.5 basis-5/12 email-domain">
                                        <FormInputComponent
                                            fieldName={`approved_email_domains[${dIndex}]`}
                                            value={domain || ''}
                                            type="text"
                                            validation={{
                                                rules: {
                                                    matchRegexp: /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
                                                },
                                                errors: {
                                                    matchRegexp: 'Invalid domain name',
                                                }
                                            }}
                                            validateBeforeSubmit={true}
                                            required={true}
                                            showRequired={false}
                                            label={false}
                                            placeholder="example.com"
                                            addonBefore="@"
                                            addonAfter={supplierOrg.approved_email_domains?.length > 1 && (
                                                <button type="button" disabled={isDisabled} onClick={async () => {
                                                    let approved_emails = TB.xor([...(supplierOrg.approved_email_domains || [])], [domain]);

                                                    await onChange({approved_email_domains: approved_emails})
                                                }}>
                                                    <i className="fas fa-times-circle text-gray"/>
                                                </button>
                                            )}
                                            maxLength={200}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                            )) : (
                                <div className="hidden-email-check px-3.5">
                                    <FormInputComponent
                                        fieldName="approved_email_domain_check"
                                        value={''}
                                        label={false}
                                        type={'text'}
                                        required={true}
                                        validationErrors={{
                                            isDefaultRequiredValue: 'You must have a least one approved email domain in order to invite talent resources.',
                                        }}
                                    />
                                </div>
                            )}

                            <div className="field-section flex row">
                                <div className="field px-3.5">
                                    <button type="button" disabled={isDisabled} className="btn btn-outline-dark mt-3"
                                            onClick={async () => {
                                                let approved_emails = [...(supplierOrg.approved_email_domains || [])];

                                                approved_emails.push('');
                                                await onChange({approved_email_domains: approved_emails})
                                            }}>
                                        Add Email Domain
                                    </button>
                                </div>
                            </div>

                        </div>

                        <hr/>

                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-4/12">
                                <FormInputComponent
                                    fieldName="logo_path"
                                    value={supplierOrg.logo_path}
                                    label={"Agency Logo"}
                                    type="pixie"
                                    ratio={"1:1"}
                                    circular={false}
                                    required={false}
                                    style={styles.field}
                                />
                            </div>
                            <div className="field px-3.5 basis-8/12">
                                <FormInputComponent
                                    fieldName="banner_image_path"
                                    value={supplierOrg.banner_image_path}
                                    label="Banner Image"
                                    labelHint="Note: Image will be cropped to 16x9 aspect for display purposes"
                                    type="pixie"
                                    ratio="16:9"
                                    circular={false}
                                    width={400}
                                    shouldResize={true}
                                    validationErrors={{
                                        isDefaultRequiredValue: 'A cover image for your portfolio is required',
                                    }}
                                    required={false}
                                    style={styles.field}
                                />
                            </div>
                        </div>
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-10/12">
                                <FormInputComponent
                                    fieldName="about"
                                    value={supplierOrg.about}
                                    label="Agency Background Info"
                                    placeholder={"Write a short description about your agency's background and/or history."}
                                    type={'editor'}
                                    required={true}
                                    style={styles.field}
                                    maxLength={10000}
                                    validation={{
                                        rules: {maxLength: 10000},
                                        errors: {
                                            maxLength: TB.trans('validation.max.string', {
                                                'attribute': 'description',
                                                'max': 10000
                                            })
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <hr/>
                        <div className="field-section flex-row">
                            <div className="field">
                                <div className="form-title-section">
                                    <div className="step-title-content">
                                        <div>
                                            <h3 className="form-title">
                                                Preferences
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-10/12">
                                <FormInputComponent
                                    fieldName="offers_service_work"
                                    value={supplierOrg.offers_service_work}
                                    label="Is your agency interested in offering fixed fee, service-based work?"
                                    type={'switch'}
                                    onLabel={'Yes'}
                                    offLabel={'No'}
                                    required={false}
                                    style={{borderBottom: '1px solid #E5E5E5', paddingBottom: 8}}
                                    switchStyle={{
                                        onColor: TB.config('color.light_green'), // green
                                        offColor: '#90A0B7', // dark gray
                                        textColor: '#000000', // black
                                    }}
                                />
                            </div>
                        </div>
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-10/12">
                                <FormInputComponent
                                    fieldName="offers_byo_work"
                                    value={supplierOrg.offers_byo_work}
                                    label="Is your agency interested in offering a-la-carte style work?"
                                    type={'switch'}
                                    onLabel={'Yes'}
                                    offLabel={'No'}
                                    required={false}
                                    style={{borderBottom: '1px solid #E5E5E5', paddingBottom: 8}}
                                    switchStyle={{
                                        onColor: TB.config('color.light_green'), // green
                                        offColor: '#90A0B7', // dark gray
                                        textColor: '#000000', // black
                                    }}
                                />
                            </div>
                        </div>


                    </div>
                </Form>
            </div>
        </div>
    )
})
export default SupplierInfoStep

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};